// DownloadDeleteConfirmModal Component
// Confirmation modal for deleting downloads

import React from 'react';
import { RevoltModal } from '../../../components/RevoltModal';
import { RevoltButton } from '../../../components/RevoltButton';
import './DownloadDeleteConfirmModal.css';

export function DownloadDeleteConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  download = null,
  isLoading = false
}) {
  if (!download) {
    return null;
  }

  const handleConfirm = async () => {
    if (onConfirm) {
      await onConfirm();
    } else {
      onClose();
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <RevoltModal
      isOpen={isOpen}
      onClose={onClose}
      title="Delete Download"
      showCloseButton={true}
    >
      <div className="download-delete-confirm-content">
        <p className="download-delete-confirm-message">
          Are you sure you want to delete the download &quot;{download.title || 'Untitled Download'}&quot;? This action cannot be undone.
        </p>
        <div className="download-delete-confirm-actions">
          <RevoltButton
            variant="outline"
            onClick={handleCancel}
            disabled={isLoading}
          >
            Cancel
          </RevoltButton>
          <RevoltButton
            variant="danger"
            onClick={handleConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <i className="fa-solid fa-spinner fa-spin" style={{ marginRight: '6px' }}></i>
                Deleting...
              </>
            ) : (
              'Delete Download'
            )}
          </RevoltButton>
        </div>
      </div>
    </RevoltModal>
  );
}

export default DownloadDeleteConfirmModal;